import React from "react"
import Icon from "../../../components/Icon/Icon"
import type {IcomoonIconName} from "../../../components/Icon/icons"
import {faQuestionCircle} from "@fortawesome/free-regular-svg-icons"
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome"
import ReactTooltip from "react-tooltip"
import BodyPortal from "../../../components/BodyPortal/BodyPortal"

export function LimitsPageBlockHeader({
	title,
	icon,
	infoTip = "",
}: {
	title: string
	icon: IcomoonIconName
	infoTip?: string
}) {
	return (
		<div className="account-limits-page-block-header">
			<div className="account-limits-page-block-header-icon">
				<Icon icon={icon} size={20} />
			</div>
			<h4>{title}</h4>
			{infoTip ? (
				<div
					className="account-limits-page-block-header-info"
					data-tip={infoTip}
					data-iscapture={true}
					data-for={"account-limits-page-info-icon"}
				>
					<FontAwesomeIcon icon={faQuestionCircle} />
					<BodyPortal>
						<ReactTooltip
							arrowColor="#FFF"
							delayHide={300}
							className="account-limits-page-info-tooltip"
							place="right"
							type="light"
							effect="solid"
							id={"account-limits-page-info-icon"}
						/>
					</BodyPortal>
				</div>
			) : null}
		</div>
	)
}

export function LimitsPageDescription() {
	return (
		<p className="account-limits-page-description">
			Some of the limits have soft and hard limits. Soft limits go straight to manual review within our compliance team
			and hard limits are auto rejected. Find more about account limits in our{" "}
			<a target="_blank" rel="noreferrer" href="https://guides.unit.co/limits/">
				<span className="underline">guide</span>
			</a>
		</p>
	)
}
